import React from "react";
import { useCardStyles } from "./shared.styles";

interface CardHeaderProps {
  icon: React.ReactElement;
  title: string;
  primaryValue: string | number;
}

const CardHeader: React.FC<CardHeaderProps> = ({
  icon,
  title,
  primaryValue,
}) => {
  const styles = useCardStyles();

  return (
    <header className={styles.header}>
      <span className={styles.largeNumber}>{primaryValue}</span>
      <hgroup className={styles.headerTitleGroup}>
        <span className={styles.headerIcon}>{icon}</span>
        <h3 className={styles.headerTitle}>{title}</h3>
      </hgroup>
    </header>
  );
};

export default CardHeader;
